export const getParentTags = function (elem, list) {
    let tagNames = list
        .toLowerCase()
        .split(',')
        .map(function (e) {
            return e.trim();
        });
    if (tagNames.indexOf(elem.tagName.toLowerCase()) > -1) return elem;
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if (tagNames.indexOf( elem.tagName.toLowerCase()) > -1) return elem;
    }
    return null;
};

export const isElement = function(elem) {
    return elem instanceof Element || elem instanceof HTMLDocument;
};

export const on = (function() {
    if (document.addEventListener) {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false);
            }
        };
    } else {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler);
            }
        };
    }
})();

export const off = (function() {
    if (document.removeEventListener) {
        return function(element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false);
            }
        };
    } else {
        return function(element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler);
            }
        };
    }
})();

